import React, { useEffect, useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select/index";
import {
  useGetEpbScannedStatewiseEciReportMutation,
  useGetStatesStatusForceWiseQuery,
} from "../../../services/reportsServices";
import "./countingsupervisoreciofficer.css";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile, parseJwt } from "../../utilities/utils";
import pdfIcon from "../../../images/pdfIcon.png";
import excelIcon from "../../../images/excelIcon.png";
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State Name",
  "AC/PC No. and Name",
  "Total e-PB Received Till 8 AM",
  "Total e-PB Received After 8 AM",
  "Scanning Completed",
];

const PrecountingCompletionReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState();
  const reportName = "e-Postal Ballot PreCounting Completion Report State Wise";
  const SheetName = "State Wise Report";

  const [Error, setError] = useState({});
  const { data: getElectionAnnouncedState } =
    useGetStatesStatusForceWiseQuery();
  const [tableData, setTableData] = useState([]);
  const stateList = [{ value: "", label: " Select State" }];
  const constType = [
    { value: "", label: "Select Constituency" },
    { value: "AC", label: "AC" },
    { value: "PC", label: "PC" },
  ];
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col2",
    },
    // {
    //   Header: "Total e-PB Received Till Date By RO",
    //   accessor: "col6",
    // },
    {
      Header: "Total e-PB Received Till 8 AM",
      accessor: "col3",
    },
    {
      Header: "Total e-PB Received After 8 AM",
      accessor: "col4",
    },
    {
      Header: "Total e-PB Rejected Without Scanning",
      accessor: "col5",
    },
  
    {
      Header: "Scanning Completed",
      accessor: "col7",
    },
  ];
  columns.map((item) => {
    tableHeader.push(item.Header);
  });
  const [states, setStates] = useState({
    stateValue: "",
    constTypeValue: "",
  });

  const [saveData, datap] = useGetEpbScannedStatewiseEciReportMutation();

  getElectionAnnouncedState?.payload?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });

  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  useEffect(()=>{
    if(localStorage?.userrole==="ceo"||localStorage?.userrole==="ceoa"){
      setStates((prevState) => ({
        ...prevState,
        ["stateValue"]: parseJwt(localStorage.access_token).authorizedStates?.[0],
      }));
    }
  },[])

  const renderTableData = () => {
    let error = {};
    if (
      !states.stateValue ||
      states.stateValue === "" ||
      states.stateValue.length == 0
    ) {
      error["stateValue"] = "This Field is required";
    }
    if (!states.constTypeValue || states.constTypeValue === "") {
      error["constTypeValue"] = "This Field is required";
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
    let payload = {
      stateCd: states.stateValue,
      constType: states.constTypeValue,
    };
    saveData(payload)
      .unwrap()
      .then((res) => {
        let tData = [];
        res?.payload?.totalAcListCount?.map((item) => {
          tData.push({
            col1: item.stateName,
            col2: item.constName,
            // col6: item.totalEpbReceivedTillDateByRO,
            col3: item.epb_Receiceived_Till_8AM,
            col4: item.epb_Receiceived_After_8AM,
            col5: item.totalEpbRejected,
            col7: item.scanning_Completed,
          });
        });
        setTableData(tData);
        setTotalNoOfRecords(res?.payload?.totalAcListCount.length);
      })
      .catch((error) => {
        if (error?.data?.message === "Data not found") {
          setTableData([]);
        }
      });
  };
  return (
    <>
      <LeftMenu>
        <div className="container box shadow ">
          <div className="row">
            <div className="col-md-12">
              <RunnerUpHeaderNew
                title={reportName}
               onPdfClick={() =>
                          downloadPdfFile(reportName, tableHeader, tableData)
                        }
                     onExcelClick={() =>
                          downloadExcelFile(
                            reportName,
                            SheetName,
                            tableHeader,
                            tableData
                          )
                        }
                    />
            </div>
          </div>
          <div className="row">
            <SelectField
              labelClass=""
              inputClass="col-md-4"
              options={stateList}
              name="stateValue"
              disabled={localStorage?.userrole==="ceo"||localStorage?.userrole==="ceoa"}
              value={states.stateValue}
              handleChange={(val) => handleChange("stateValue", val)}
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("stateValue", val)}
              Error={Error}
            ></SelectField>
            <SelectField
              labelClass=""
              inputClass="col-md-2 pr-1"
              value={states.constTypeValue}
              name="constTypeValue"
              handleChange={(val) => handleChange("constTypeValue", val)}
              options={constType}
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("constTypeValue", val)}
              Error={Error}
            />
            <div className="col-md-2 ">
              <button
                type="button"
                className="btn btn-primary btn-sm searchbuttonreport"
                onClick={renderTableData}
              >
                VIEW
                <span className="pl-2">
                  <i class="fa fa-eye"></i>
                </span>
              </button>
            </div>
          </div>
          {datap.isSuccess && (
            <div className="row mt-3 dashboardChart">
              <div className="col-md-3">
                <div class=" l-bg-cyan-dark" style={{ borderRadius: "7px" }}>
                  <div className="">
                    <p className="text-center p-0 m-0">State</p>
                  </div>
                  <div className="">
                    <p className="text-center">{datap?.data?.payload?.totalAcListCount[0]?.stateName}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div class=" l-bg-grey-dark" style={{ borderRadius: "7px" }}>
                  <div className="">
                    <p className="text-center p-0 m-0">Total No Of {states?.constTypeValue}s</p>
                  </div>
                  <div className="">
                    <p className="text-center">
                      {datap?.data?.payload?.totalAcCount?.total_Ac}
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3">
                <div class=" l-bg-cyan-dark" style={{ borderRadius: "7px" }}>
                  <div className="">
                    <p className="text-center p-0 m-0">
                    e-PB Received Till Date By RO
                    </p>
                  </div>
                  <div className="">
                    <p className="text-center">
                      {
                        datap?.data?.payload?.totalAcCount
                          ?.totalEpbReceivedTillDateByRO
                      }
                    </p>
                  </div>
                </div>
              </div> */}
              <div className="col-md-3">
                <div class=" l-bg-orange-dark" style={{ borderRadius: "7px" }}>
                  <div className="">
                    <p className="text-center p-0 m-0">
                      Total e-PB Received Till 8 AM
                    </p>
                  </div>
                  <div className="">
                    <p className="text-center">
                      {
                        datap?.data?.payload?.totalAcCount
                          ?.epb_Receiceived_Till_8AM
                      }
                    </p>
                  </div>
                </div>
              </div>{" "}
              <div className="col-md-3">
                <div class=" l-bg-green-dark" style={{ borderRadius: "7px" }}>
                  <div className="">
                    <p className="text-center p-0 m-0">
                      Total e-PB Received After 8 AM
                    </p>
                  </div>
                  <div className="">
                    <p className="text-center">
                      {
                        datap?.data?.payload?.totalAcCount
                          ?.epb_Receiceived_After_8AM
                      }
                    </p>
                  </div>
                </div>
              </div>{" "}
              <div className="col-md-3">
                <div class=" l-bg-blue-dark" style={{ borderRadius: "7px" }}>
                  <div className="">
                    <p className="text-center p-0 m-0">
                      Total {states?.constTypeValue}s with Scanning Completed
                    </p>
                  </div>
                  <div className="">
                    <p className="text-center">
                      {
                        datap?.data?.payload?.totalAcCount
                          ?.total_scanning_completed
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div class=" l-bg-green-dark" style={{ borderRadius: "7px" }}>
                  <div className="">
                    <p className="text-center p-0 m-0">
                    e-PB Rejected Without Scanning
                    </p>
                  </div>
                  <div className="">
                    <p className="text-center">
                      {
                        datap?.data?.payload?.totalAcCount
                          ?.totalEpbRejected
                      }
                    </p>
                  </div>
                </div>
              </div>{" "}
              
            </div>
          )}
          <div style={{ marginTop: "0px" }}>
            <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              columns={columns}
              emptyMessage="No Record Found"
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
          </div>
        </div>
      </LeftMenu>
    </>
  );
};

export default PrecountingCompletionReport;
